export const colors = {
  primary: {
    '50': '#F3FAF3',
    '100': '#F3FAF3',
    '200': '#E8F6E9',
    '300': '#D1E5D5',
    '400': '#B5CBBB',
    '500': '#91A99A',
    '600': '#69917C',
    '700': '#497964',
    '800': '#2E6251',
    '900': '#1B5144',
  },
  secondary: {
    '50': '#FEF9CB',
    '100': '#FEF9CB',
    '200': '#FEF398',
    '300': '#FEE965',
    '400': '#FDE03F',
    '500': '#FCD200',
    '600': '#D8B000',
    '700': '#B59000',
    '800': '#927200',
    '900': '#927200',
  },
};
